export const SSOLoginConstant =
    {
        SSO_AZURE:"1",
        SSO_ONELOGIN:"2",
        SSO_OTHER:"3" 
    }
